/* eslint-disable no-var */
import { PageIcon } from "@/types";
import CanvasManager from "./CanvasManager";
import IconManager from "./IconManager";
import { Strategy } from "./StrategyManager";
import {
  getCloseGapFillingBtnId,
  getQuestionAnswerBtnId,
  getShowGapFillingBtnId,
  getShowQuestionAnswerBtnId,
} from "@/database/smartBookModelService";
import { ImageManager } from "./ImageManager";
import { fabric } from "@/@corefabriccanvas/fabric/dist/fabric";
export class OpenGapFillingStrategy implements Strategy {
  constructor() {}
  execute(
    item: PageIcon,
    canvasManager: CanvasManager,
    imageManager: ImageManager,
    iconManager: IconManager
  ): void {
    iconManager.hideIconById(item.id);
    const closeAnswerBtnId = getCloseGapFillingBtnId(item.entityId);
    iconManager.showIconById(closeAnswerBtnId);
    const coordinate = canvasManager.getBackgroundImageCoordinate();
    if (!item.correctAnswer) {
      this.showGapFillingImage(item, coordinate, imageManager);
    } else {
      this.showTextAnswer(item, coordinate, canvasManager);
    }
  }

  showGapFillingImage = async (
    item: PageIcon,
    coordinate: { imgLeft: number; imgTop: number },
    imageManager: ImageManager
  ) => {
    imageManager.addImage(
      `${item.gapFillingOptionImage}`,
      {
        left: coordinate.imgLeft + item.x,
        top: coordinate.imgTop + item.y,
        id: `gapFillingAnswer-${item.entityId}`,
        erasable: false,
        selectable: false,
        evented: false,
      },
      item.width
    );
  };

  showTextAnswer = async (
    item: PageIcon,
    coordinate: { imgLeft: number; imgTop: number },
    canvasManager: CanvasManager
  ) => {
    var lineCount = item.correctAnswer.split(/\r\n|\r|\n/).length;
    const iText = new fabric.IText(item.correctAnswer, {
      left: coordinate.imgLeft + item.x,
      top: coordinate.imgTop + item.y,
      erasable: false,
      selectable: false,
      backgroundColor: "transparent",
      clearOnReset: true,
      fontSize: item.height / lineCount,
      fill: "red",
      evented: false,
      id: `gapFillingAnswer-${item.entityId}`,
    });
    canvasManager.addObject(iText);
  };
}

export class CloseGapFillingStrategy implements Strategy {
  constructor() {}
  execute(
    item: PageIcon,
    canvasManager: CanvasManager,
    imageManager: ImageManager,
    iconManager: IconManager
  ): void {
    iconManager.hideIconById(item.id);
    const closeAnswerBtnId = getShowGapFillingBtnId(item.entityId);
    iconManager.showIconById(closeAnswerBtnId);
    const imageId = `gapFillingAnswer-${item.entityId}`;
    canvasManager.removeObjectById(imageId);
  }
}

export class OpenQuestionAnswerStrategy implements Strategy {
  constructor() {}
  async execute(
    item: PageIcon,
    canvasManager: CanvasManager,
    imageManager: ImageManager,
    iconManager: IconManager
  ): Promise<void> {
    iconManager.hideIconById(item.id);
    if (item.hasSecondLayer) {
      const coordinate = canvasManager.getBackgroundImageCoordinate();
      imageManager.addImage(
        `${item.secondLayer}`,
        {
          left: coordinate.imgLeft + item.x,
          top: coordinate.imgTop + item.y,
          id: `secondLayer-${item.entityId}`,
          erasable: false,
          selectable: false,
          evented: false,
        },
        item.width
      );
    }
    const questionAnswerIcon = getQuestionAnswerBtnId(item.entityId);
    iconManager.showIconById(questionAnswerIcon);
  }
}

export class CloseQuestionAnswerStrategy implements Strategy {
  constructor() {}
  execute(
    item: PageIcon,
    canvasManager: CanvasManager,
    imageManager: ImageManager,
    iconManager: IconManager
  ): void {
    iconManager.hideIconById(item.id);
    const questionAnswerIcon = getShowQuestionAnswerBtnId(item.entityId);
    iconManager.showIconById(questionAnswerIcon);
    if (item.hasSecondLayer) {
      canvasManager.removeObjectById(`secondLayer-${item.entityId}`);
    }
  }
}

export class CollapseSecondLayerStrategy implements Strategy {
  constructor() {}
  async execute(
    item: PageIcon,
    canvasManager: CanvasManager,
    imageManager: ImageManager,
    iconManager: IconManager,
    isSecondLayerVisible: boolean
  ): Promise<void> {
    try {
      if (isSecondLayerVisible) {
        const coordinate = canvasManager.getBackgroundImageCoordinate();
        const backgroundImage = canvasManager.getBackgroundImage();
        imageManager.addImage(
          `${item.secondLayer}`,
          {
            left: coordinate.imgLeft,
            top: coordinate.imgTop,
            id: `secondLayer-${item.entityId}`,
            erasable: false,
            selectable: false,
            evented: false,
          },
          backgroundImage.width * backgroundImage.scaleX
        );
      } else {
        canvasManager.removeObjectById(`secondLayer-${item.entityId}`);
      }
    } catch (e) {
      console.error(e);
    }
  }
}
